.page { min-height: 100%; background: var(--bg); color: var(--tx); padding: 24px clamp(16px, 4vw, 48px) 56px; display: flex; flex-direction: column; gap: 20px; }
.head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.head h1 { margin: 0; font-size: 26px; font-weight: var(--fw-title); letter-spacing: -0.02em; }
.card { padding: 22px 24px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); display: flex; flex-direction: column; gap: 16px; min-width: 0; }
.card h2 { margin: 0; font-size: 18px; font-weight: var(--fw-title); }
.row { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 14px; }
.grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.states { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 20px; }
.states .card { padding: 0; }
.id { font-weight: var(--fw-label); color: var(--link); }
